<h2 mat-dialog-title>Notification</h2>
<div mat-dialog-content>
    <p>Are you sure you want to {{data}} the booking?</p>
</div>
<div mat-dialog-actions align="end" class="modal-footer d-flex gap-10 flex-nowraps">
    <button class="btn btn-success" (click)="submit()">Submit</button>
    <button class="btn btn-secondary" (click)="cancelDialog()">Cancel</button>
</div>